import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import styles from "./Canned.module.css";
import { useLanguage } from "../i18n/LanguageContext";

const categories = [
  {
    key: "olives",
    link: "/products/canned-vegetables/olives",
  },
  {
    key: "cucumbers",
    link: "/products/canned-vegetables/cucumbers",
  },
  {
    key: "tomatoPaste",
    link: "/products/canned-vegetables/tomato-paste",
  },
];

const CannedVegetables = () => {
  const { t } = useLanguage();

  return (
    <Layout>
      <h2 className={styles.heading}>{t("vegetables.title")}</h2>

      <div className={styles.grid}>
        {categories.map((cat) => (
          <Link to={cat.link} key={cat.key} className={styles.card}>
            <h3>{t(`vegetables.${cat.key}.title`)}</h3>
            <p>{t(`vegetables.${cat.key}.description`)}</p>
          </Link>
        ))}
      </div>
    </Layout>
  );
};

export default CannedVegetables;
